import ApplianceRender from "../ApplianceRender";

const DiningHall = () => {

    return (
        <ApplianceRender roomName={"DiningHall"}/>
    )
}

export default DiningHall